import { render } from "./rubric-list-item.vue?vue&type=template&id=4cad67e7&ts=true"
import script from "./rubric-list-item.vue?vue&type=script&lang=ts"
export * from "./rubric-list-item.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__